import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CustomDirectivesModule } from "@app/_directives/custom-directives.module";
import { EntityRefPipesModule } from "@app/_pipes/entity-ref-pipes/entity-ref-pipes.module";
import { DurationInputControlModule } from "@app/components/duration-input-control/duration-input-control.module";
import { MaterialModule } from "@app/material.module";
import { SatPopoverModule } from "@ncstate/sat-popover";
import { TranslateModule } from "@ngx-translate/core";
import { DateFnsModule } from "ngx-date-fns";
import { NgxMaskDirective } from "ngx-mask";
import { ClientprojectPickerModule } from "../clientproject-picker/clientproject-picker.module";
import { ClientProjectPickerDialogModule } from "../dialogs/client-project-picker-dialog/client-project-picker-dialog.module";
import { TagPickerDialogModule } from "../dialogs/tag-picker-dialog/tag-picker-dialog.module";
import { LoaderModule } from "../loader/loader.module";
import { TimeDatePickerModule } from "../time-date-picker/time-date-picker.module";
import { TimeInputModule } from "../time-input/time-input.module";
import { TimeTrackerEntryComponent } from "./time-tracker-entry.component";

@NgModule({
	declarations: [TimeTrackerEntryComponent],
	imports: [
		CommonModule,
		MaterialModule,

		FormsModule,
		ReactiveFormsModule,
		ClientprojectPickerModule,
		SatPopoverModule,
		LoaderModule,
		NgxMaskDirective,
		TranslateModule,
		TimeDatePickerModule,
		CustomDirectivesModule,
		TimeInputModule,
		DurationInputControlModule,
		ClientProjectPickerDialogModule,
		DateFnsModule,
		EntityRefPipesModule,
		TagPickerDialogModule,
	],
	exports: [TimeTrackerEntryComponent],
})
export class TimeTrackerEntryModule {}
